import { CHAIN_NAME_KEY } from '../constants'

export default () => {
  return localStorage.getItem(CHAIN_NAME_KEY)
}
